import { createAction, props } from '@ngrx/store';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~ Upload Picture Actions ~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const showUploadPictureDialog = createAction(
  '[UploadPicture/UI] Open Upload Picture Modal',
);

export const closeUploadPictureDialog = createAction(
  '[UploadPicture/UI] Close Upload Picture Modal',
);

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~ Upload Picture Actions ~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const uploadPicture = createAction(
  '[UploadPicture/API] UploadPicture',
  props<{ file: File }>(),
);

export const uploadPictureSuccess = createAction(
  '[UploadPicture/API] UploadPicture Success',
);

export const uploadPictureFailure = createAction(
  '[UploadPicture/API] UploadPicture Failure',
  props<{ error: string }>(),
);

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~ Verify With Picture Picture Actions ~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const verifyWithPicture = createAction(
  '[VerifyWithPicture/API] Verify With Picture',
);

export const verifyWithPictureSuccess = createAction(
  '[VerifyWithPicture/API] Verify With Picture Success',
);

export const verifyWithPictureFailure = createAction(
  '[VerifyWithPicture/API] Verify With Picture Failure',
  props<{ error: string }>(),
);

export const cleanError = createAction(
  '[VerifyWithPicture/API] Cleaning error',
);

export const resetState = createAction('[VerifyWithPicture/API] Reset State');
